const CheckoutStepsSkeleton = () => (
  <section className="py-4 lg:py-8">
    <ul className="brand-text-sm brand-container lg:brand-text-md flex max-w-screen-md animate-pulse items-center justify-center gap-2 text-neutral lg:gap-4">
      {[...Array(4)].map((_, index) => (
        <li key={index} className="flex items-center gap-1 *:bg-base-300 lg:gap-2">
          <div className="h-4 w-12 rounded lg:w-16" />
          {index < 3 && <div className="size-4 rounded-full" />}
        </li>
      ))}
    </ul>
  </section>
);

export default CheckoutStepsSkeleton;
